import { MockAdGroup } from '@components/tests/__mocks__';
import moment from 'moment';
import { BulkEditFieldValueState } from '../../constants';
import { Campaign } from '@local-types';

const parseToMoment = (dateTime: string | null | undefined) =>
  dateTime === null || dateTime === undefined ? undefined : moment(dateTime);

export const getSameValues = (adGroups: MockAdGroup[]) => {
  if (!adGroups || !adGroups.length) {
    return {
      sameStart: false,
      sameEnd: false,
    };
  }

  return {
    sameStart: adGroups.every(
      group => group.start_date === adGroups[0].start_date,
    ),
    sameEnd: adGroups.every(group => group.end_date === adGroups[0].end_date),
  };
};

// If ad groups all have the same start or end date and time,
// use that shared value as the initial value
const getInitialValues = (adGroups: MockAdGroup[]) => {
  if (!adGroups.length) return {};

  const { sameStart, sameEnd } = getSameValues(adGroups);

  const start = adGroups[0].start_date;
  const end = adGroups[0].end_date;

  return {
    startDateTime: sameStart ? parseToMoment(start) : undefined,
    endDateTime: sameEnd ? parseToMoment(end) : undefined,
  };
};

export const getDefaultValues = (
  adGroups: MockAdGroup[],
  fieldValues: BulkEditFieldValueState,
) => {
  if (!fieldValues || fieldValues === 'None')
    return getInitialValues(adGroups);

  return {
    startDateTime: parseToMoment(fieldValues.start_date),
    endDateTime: parseToMoment(fieldValues.end_date),
  };
};

export const getDateTimeRange = (campaign?: Campaign) => {
  return {
    minDateTime: campaign ? moment(campaign?.start_date) : moment(),
    maxDateTime: campaign ? moment(campaign?.end_date) : undefined,
  };
};
